// import Home from './App.vue';
import Component from './Component.vue';

const {
	createRouter,
	createMemoryHistory,
	createWebHistory,
} = require('vue-router');

const routes = [

	// { path: '/', name: 'home', component: Home },
	{ path: '/assetid-:articleid', component: Component },
	{ path: '/assetid-:articleid/:channelid', component: Component },
];

export default function () {
	const isServer = typeof window === 'undefined';
	const history = isServer ? createMemoryHistory() : createWebHistory();
	return createRouter({ routes, history });
}
